
<div style="position: relative">
    <c-card-iterator
        :items          = "filteredItems"
        :label          = "title"
        :loading        = "loading"
        :title-prefix   = "true"
        :pagination-on  = "true"
        :item-height    = "112"
        :min-height     = "topHeight"
        :filter         = "match"
        :filter-height  = "311"
        :height         = "height"
        @search         = "onSearch"
    >
        <template v-slot:filter>
            <div class="mt-4">
                <div class="primary--text">
                    {{ $t("todo.assessment.prio.label") }}
                </div>
                <div>
                    <v-switch
                        v-model = "filter.prio.high"
                        :ripple = "false"
                        color="error"
                        class="mt-1"
                        hide-details
                    >
                        <template v-slot:label>
                            <div class="error prio-filter-label" />
                            <div >
                                {{ $t("todo.assessment.prio.high") }}
                            </div>
                        </template>
                    </v-switch>
                </div>

                <div>
                    <v-switch
                        v-model = "filter.prio.middle"
                        :ripple = "false"
                        class="mt-1"
                        color="warning"
                        hide-details
                    >
                        <template v-slot:label>
                            <div class="warning prio-filter-label"  />
                            <div >
                                {{ $t("todo.assessment.prio.middle") }}
                            </div>
                        </template>
                    </v-switch>
                </div>

                <div >
                    <v-switch
                        v-model = "filter.prio.low"
                        :ripple = "false"
                        hide-details
                        color="success"
                        class="mt-1"
                    >
                        <template v-slot:label>
                            <div class="success prio-filter-label" />
                            <div >
                                {{ $t("todo.assessment.prio.low") }}
                            </div>
                        </template>
                    </v-switch>
                </div>

                <div class="mb-4">
                    <v-switch
                        v-model = "filter.prio.none"
                        :ripple = "false"
                        class="mt-1"
                        hide-details
                    >
                        <template v-slot:label>
                            <div class="lm-border prio-filter-label" />
                            <div >
                                {{ $t("todo.assessment.prio.none") }}
                            </div>
                        </template>
                    </v-switch>
                </div>

                <v-divider />
                <f-date-picker
                    label="Letzte Bearbeitung vor"
                    v-model="filter.modified"
                    class="mb-2 mt-2 w-50"
                    hide-details
                />
            </div>
        </template>
        <template v-slot:card="{ item }">
            <p-inc-assessment-card
                :item   = "item"
                :result = "type"
                @site   = "onSite"
            />
        </template>
    </c-card-iterator>

    <div v-if="(!items || items.length === 0) && !loading" class="lm-border empty-todos">
        <v-icon color="success" size="30">mdi-check-circle</v-icon>
    </div>
</div>
